import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import icSelect from '../static/select.svg';
import icSelectDisabled from '../static/select_disabled.svg';
import { field } from '../Input/style/default';

interface IWrapStyleOptions {
  readonly?: boolean;
}

const wrap =
  ({ readonly }: IWrapStyleOptions) =>
  (): CSSObject => ({
    ...field,
    width: '218px',
    maxWidth: '100%',
    height: '40px',
    fontSize: '14px',
    appearance: 'none',
    padding: '0 36px 0 12px',
    background: `${theme.color.white} url(${icSelect}) no-repeat`,
    backgroundPosition: 'right 12px center',
    cursor: 'pointer',
    ':disabled': {
      color: theme.color.grey400,
      background: `${theme.color.grey50} url(${icSelectDisabled}) no-repeat`,
      backgroundPosition: 'right 12px center',
      cursor: 'not-allowed',
    },

    ...(readonly && {
      fontWeight: 600,
      outline: 'none',
      pointerEvents: 'none',
      background: theme.color.grey50,
    }),
  });

export { wrap };
